module.exports = __webpack_public_path__ + "img/module-thumb.c86f3934.jpg";